import { render } from "./PayPage.vue?vue&type=template&id=24c45bcd"
import script from "./PayPage.vue?vue&type=script&lang=js"
export * from "./PayPage.vue?vue&type=script&lang=js"
script.render = render

export default script